import {concat, filter, get, map, some, sortBy} from 'lodash';
import {useMemo} from 'react';
import {SRStatus} from '../../../../../global/api';
import {GetDashboardQueryParams, useGetDashboardQuery} from '../../../../../global/services/dashboard';
import {useGetDictsServiceTypesStatusesQuery} from '../../../../../global/services/service-types';
import {STATUS_OPTIONS_MAP} from '../constants/status';

interface StatusOption {
  value?: string;
  label?: string;
}

type Period = NonNullable<GetDashboardQueryParams>['period'];

interface UseStatusOptionsParams {
  serviceType: string;
  period: string;
  from: string;
  to: string;
}

const mapStatus = (item: SRStatus): StatusOption => ({
  value: item.statusCode,
  label: item.statusName,
});

export const useStatusOptions = ({period, ...props}: UseStatusOptionsParams) => {
  const {data, loading} = useGetDictsServiceTypesStatusesQuery({});
  const {data: dashboardData, loading: dashboardLoading} = useGetDashboardQuery({...props, period: period as Period});
  const statuses = get(dashboardData, 'totals.lastStatuses', []);

  const filtered = useMemo(() => filter(data, (item) => some(statuses, {status: item.statusCode})), [data, statuses]);
  const sorted = useMemo(() => sortBy(filtered, ['sortOrder']), [filtered]);
  const statusOptions = useMemo(() => concat(map(sorted, mapStatus), [STATUS_OPTIONS_MAP.ALL]), [sorted]);

  return {
    statusOptions: statusOptions || [],
    loading: loading || dashboardLoading,
  };
};
